import React from "react";
import Grid from "@material-ui/core/Grid";
import '../../../../App.scss';
import Star from "../../../../assets/images/state_star.png";
import StarEmpty from "../../../../assets/images/state_star_empty.png";
import Light from "../../../../assets/images/light.png";
import Button from "../../Settings/Free/Button";
import GoldBanner from "../../../../assets/images/gold_banner.png";
import BannerImage from "../../../../assets/images/ribbon_in_black_version.png";
import Green from "../../../../assets/images/green.png";
import Red from "../../../../assets/images/red.png";
import Purple from "../../../../assets/images/purple.png";
import Image from "../Question/Image";
import Car from "../../../../assets/images/car.jpg";
import roundLight from "../../../../assets/images/img_raund_light.png";
import GozineSelect from "../../../../assets/images/game_gozine_select.png";
import GoldCoin from "../../../../assets/images/ic_coin.png";
import Try from "../../../../assets/images/try_icon.png";
import BlackButton from "../../../../components/pageComponents/Settings/Free/BlackButton";
import {withRouter} from "react-router-dom";
import Snackbar from "@material-ui/core/Snackbar";
import axios from "axios";
import {report, sessionHelp} from "../../../../Utility/Url";
import PicoLoader from "../../Common/PicoLoader";
import {data, data as rxData} from "../../../../Store/Actions/DataAction";
import {COINCHANGE} from "../../../../Store/Actions/Types";
import {connect} from "react-redux";
import {giftHallDialog} from "../../../../Store/Actions/GiftHallDialogAction";
import DialogContent from "@material-ui/core/DialogContent";
import ShopDialog from "../../Common/ShopDialog";
import Dialog from "@material-ui/core/Dialog";
import Loose from "../../../../assets/mp3/lose.mp3";
import Win from "../../../../assets/mp3/win.mp3";


class Result extends React.Component{
    constructor(props){
        super(props)
        this.state={
            type:false,
            vertical: 'bottom',
            horizontal: 'center',
            snackMessage:'',
            open: false,
            canReport:false,
            tryLoader:false,
            showDialog:false,
            dialogDetail:null
        }
    }
    async componentDidMount() {
        this.setState({
            canReport:true
        })
        if (this.props.data.data.success && !this.props.timeOut) {
            await new Audio(Win).play()
        }else {
            await new Audio(Loose).play()
        }
    }
    handleRetry=async ()=>{
        this.setState({
            tryLoader:true
        })
        await axios.post(sessionHelp,{
            sessionID:this.props.sessionId,
            type:'try'
        })
            .then(res => {
                const {data}=res
                this.setState({
                    tryLoader:false
                })
                if (data.success){
                    this.props.rxData({coinType:'golden',value:1,type:'decrement'},COINCHANGE)
                    this.props.nextQuestion()
                }
                else {
                    localStorage.setItem('redirect','/league-start/question')
                    localStorage.setItem('sessionId',this.props.sessionId)
                    localStorage.setItem('gameType',this.props.gameType)
                    localStorage.setItem('imageType',this.props.imageType)

                    this.setState({
                        dialogDetail:data.shopItem
                    },()=>{
                        this.setState({
                            showDialog:true
                        })
                    })
                }
            }).catch(error=>{
                    console.log(error.toString())
                }
            )
    }
    report=(id)=>{
        axios.post(report,{
            id:id
        })
            .then(res => {
                console.log(res)
                }
            )
        this.setState({
            canReport:false,
            open:true,
            snackMessage:'گزارش با موفقیت ارسال شد'
        })
        setTimeout(()=>{
            this.setState({
                open:false,
            })
        },3000)
    }
    // handleDialogActi
    handleClose=()=>{
        localStorage.removeItem('redirect')
        this.setState({
            showDialog:false
        })
    }
    render() {
        const button={
            text:'بریم سوال بعدی',
            backgroundColor:'green',
            bottomFontSize:'15px',
            buttonTextColor:'#ffffff',
            borderColor:'#000000'
        }
        const backButton={
            text:'بازگشت',
            backgroundColor:'red',
            bottomFontSize:'100%',
            buttonTextColor:'#ffffff',
            borderColor:'#000000'
        }
        const winnerTableButton={
            text:'جدول برندگان',
            backgroundColor:'yellow',
            bottomFontSize:'100%',
            buttonTextColor:'#000000',
            borderColor:'#000000'
        }
        const faultReport={
            text:'گزارش خطا',
            backgroundColor:'red',
            bottomFontSize:'15px',
            buttonTextColor:'#ffffff',
            borderColor:'#000000'
        }
        const blackButton={
            backgroundColor:'black',
            blackButtonTextColor:'#ffffff',
            text:1,
            textColor:'#ffffff',
            icon:GoldCoin
        }
        const {data:{success,try:{isValid,withVideo}},question:{text,id}}=this.props.data
        const gameType=this.props.gameType
        const timeOut=this.props.timeOut
        const sessionId=this.props.sessionId
        const questionNumber=this.props.questionNumber+1
        const {vertical,
            horizontal,
            snackMessage,
            open,canReport,dialogDetail}=this.state
        const customDialog={
            button:{
                text:'',
                backgroundColor:'transparent',
                bottomFontSize:'15px',
                buttonTextColor:'red',
                borderColor:'transparent'
            },
            data:{
                dialog:dialogDetail,
            }
        }
        return(
            <Grid item container alignItems={"center"} sm={12} xs={12} justify={"center"}
                  className='result'
                  style={{backgroundColor:(success && !timeOut)?'green':(!success && !timeOut)?'red':'purple'}}
            >
                <Dialog
                    // disableBackdropClick
                    open={this.state.showDialog}
                    onClose={this.handleClose}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                    style={{background:'transparent !important'}}
                    PaperProps={{
                        style: {
                            backgroundColor: 'transparent',
                            boxShadow: 'none',
                        },
                    }}
                >
                    <DialogContent>
                        <ShopDialog action={this.handleDialogAction} data={customDialog}/>
                    </DialogContent>
                </Dialog>
                <Grid item container alignItems={"center"} sm={12} xs={12} justify={"center"}
                  className='result-inner'
                >
                    {
                        success &&
                        <Grid item container className='result-inner-light' alignItems={"center"} sm={10} xs={10} justify={"center"}>
                            <img className='result-inner-light-image lightAnimation' src={roundLight} alt=""/>
                        </Grid>
                    }

                    <Grid item container className='result-inner-banner' style={{position:'relative'}} alignItems={"center"} sm={10} xs={10} justify={"center"}>
                        {
                           ((success) &&( gameType==='normal' ))&&
                            <Grid container alignItems={"center"} justify={"space-around"} style={{
                                transform:'translateY(-70%)',
                                position:'absolute',

                            }}>

                                <Grid alignItems={"center"} container justify={"center"} xs={3} sm={3}
                                      style={{alignSelf:'flex-end',transform:'rotate(-20deg)'}}>
                                    {questionNumber>0 &&
                                    <img className='question-true-star-light' src={Light} alt=""/>
                                    }
                                    <img className='question-true-star-image' src={
                                        questionNumber>0? Star:StarEmpty} alt=""/>
                                </Grid>
                                <Grid alignItems={"center"} container justify={"center"} xs={5} sm={5}
                                      style={{alignSelf:'flex-start'}}
                                >
                                    {questionNumber > 1 &&
                                    <img className='question-true-star-light' src={Light} alt=""/>
                                    }
                                    <img className='question-true-star-image' src={
                                        questionNumber>1? Star:StarEmpty} alt=""/>
                                </Grid>
                                <Grid alignItems={"center"} container justify={"center"} xs={3} sm={3}
                                      style={{alignSelf:'flex-end',transform:'rotate(20deg)'}}>
                                    {questionNumber > 2 &&
                                    <img className='question-true-star-light' src={Light} alt=""/>
                                    }
                                    <img className='question-true-star-image' src={
                                        questionNumber>2? Star:StarEmpty} alt=""/>
                                </Grid>

                            </Grid>
                        }
                        {
                            (success && !timeOut) &&
                                <img className='result-inner-banner-image' src={Green} alt=""/>
                        }
                        {
                            (!success && !timeOut) &&
                                <img className='result-inner-banner-image' src={Red} alt=""/>
                        }
                         {
                            ( (timeOut && !success) || (timeOut && success) )&&
                                <img className='result-inner-banner-image' src={Purple} alt=""/>
                        }
                       {
                           (success && !timeOut) &&
                           <p className='result-inner-banner-text' style={{color:'#ffffff'}}>
                               جوابت درست بود
                           </p>
                       }
                       {
                           (!success && !timeOut) &&
                           <p className='result-inner-banner-text' style={{color:'#ffffff'}}>
                               جوابت اشتباه بود
                           </p>

                       }
                       {
                           ( (timeOut && !success) || (timeOut && success) )&&
                           <p className='result-inner-banner-text' style={{color:'#ffffff'}}>
                               زمانت تموم شد
                           </p>

                       }
                    </Grid>
                    {/*//talash mojadad*/}
                    {
                        // (!success && (isValid && withVideo) && gameType!=='train') &&
                        (!success && (isValid) && gameType!=='train') &&
                            <>
                                {
                                    !this.state.tryLoader?(
                                        <Grid item container style={{
                                            position:'relative',
                                            backgroundImage:`url(${GozineSelect})`,
                                            backgroundSize:'100% 80%',
                                            backgroundRepeat:'no-repeat',
                                            margin:'10px 0',
                                            backgroundPosition:'center'
                                        }} alignItems={"center"} sm={10} xs={10} justify={"space-evenly"}
                                              onClick={()=>{
                                                  this.handleRetry()
                                              }}
                                        >
                                            <Grid container style={{height:'50px'}} sm={4} xs={4} justify={"center"} alignItems={"center"}>
                                                <BlackButton data={blackButton} />
                                            </Grid>
                                            <Grid container justify={"center"} alignItems={"center"} sm={3} xs={3}>
                                                <p style={{fontSize:'1.3rem'}}>
                                                    تلاش مجدد
                                                </p>
                                            </Grid>
                                            <Grid container sm={3} xs={3} justify={"center"} alignItems={"center"} style={{transform:'translateX(15%)'}}>
                                                <img src={Try} style={{width:'50%'}} alt=""/>
                                            </Grid>
                                        </Grid>
                                            ):(
                                            <Grid sm={11} xs={11} container alignItems={"center"} direction={"row-reverse"} justify={"center"}
                                                  style={{position:'relative',height:'50px'}}
                                            >
                                                <Grid item sm={2} xs={2} container justify={"center"} alignItems={"center"} style={{position:'absolute'}}>
                                                    <PicoLoader/>
                                                </Grid>
                                            </Grid>
                                            )
                                }

                            </>

                    }
                    {/*//*/}
                    <Grid item container style={{position:'relative'}} alignItems={"center"} sm={10} xs={10} justify={"center"}>
                        <p className='result-inner-answer'>
                            {text}
                        </p>
                        <img src={GoldBanner}  className='result-inner-image' alt=""/>
                    </Grid>
                    {
                        success &&
                        <Grid item container style={{borderRadius:'20px',overflow:'hidden'}} alignItems={"center"} sm={8} xs={8} justify={"center"}>
                            <Image data={this.props.data.image}/>
                        </Grid>
                    }
                    {
                        !success &&
                        <Grid item container  direction={"column"} alignItems={"center"} sm={8} xs={8} justify={"center"}>
                            <Grid container style={{borderRadius:'20px',overflow:'hidden',position:'relative',zIndex:'5'}}>
                                <Image data={this.props.data.image}/>
                            </Grid>
                            <Grid container xs={8} sm={8} style={{height:'30px',width:'100%',transform:'translateY(-50%)',position:'relative',zIndex:'6'}}>
                                {
                                    canReport &&
                                    <Grid container style={{height:'30px'}} className={'clickable'}
                                          onClick={()=>{
                                              this.report(id)
                                          }}
                                    >
                                        <Button data={faultReport}/>
                                    </Grid>
                                }

                            </Grid>

                        </Grid>
                    }

                    {
                        success &&
                        <Grid item container alignItems={"center"}
                              className='result-inner-button-container'
                              sm={6} xs={6} justify={"center"} onClick={()=>{
                                  this.props.nextQuestion()
                        }}>
                            <Button data={button}/>
                        </Grid>
                    }
                    {
                        !success &&
                        <Grid item container alignItems={"center"}
                              className='result-inner-button-container'
                              style={{marginTop:'-30px'}}
                              sm={10} xs={10} justify={"space-around"}>
                            {
                                gameType!=='train' &&
                                <Grid container sm={5} xs={5} style={{height:'100%'}}
                                      className='clickable'
                                      onClick={()=>{
                                          this.props.history.push(`/winners-table`)
                                      }}
                                >
                                    <Button data={winnerTableButton}/>
                                </Grid>
                            }

                            <Grid container sm={5} xs={5} style={{height:'100%'}}
                                  className='clickable'
                                  onClick={()=>{
                                      window.history.back()
                                      // this.props.history.push(`/league-start`)
                                  }}
                            >
                                <Button data={backButton}/>
                            </Grid>
                        </Grid>
                    }
                    <Snackbar
                        anchorOrigin={{ vertical, horizontal }}
                        open={open}
                        message={snackMessage}
                        key={vertical + horizontal}
                    />
                </Grid>
            </Grid>
        )
    }
}
const mapStateToProps=state=>({
    UserData:state.UserData,
})

export default connect(mapStateToProps,{rxData})(withRouter(Result))